/**
 * Action Types
 */

import {
  ADMIN_CLEAR,
  ADMIN_PARTNERS_PROGRAMS_REQUEST,
  ADMIN_PARTNERS_PROGRAMS_RECEIVE,
  ADMIN_PARTNERS_PROGRAMS_FAILURE,
  ADMIN_PARTNERS_PROGRAM_REQUEST,
  ADMIN_PARTNERS_PROGRAM_RECEIVE,
  ADMIN_PARTNERS_PROGRAM_FAILURE,
  ADMIN_AFFILIATE_PROGRESS_REQUEST,
  ADMIN_AFFILIATE_PROGRESS_RECEIVE,
  ADMIN_AFFILIATE_PROGRESS_FAILURE,
  ADMIN_PENDING_COMMISSIONS_REQUEST,
  ADMIN_PENDING_COMMISSIONS_RECEIVE,
  ADMIN_PENDING_COMMISSIONS_FAILURE,
  ADMIN_COMMISSION_APPROVE_REQUEST,
  ADMIN_COMMISSION_APPROVE_FAILURE,
  ADMIN_COMMISSION_DISAPPROVE_REQUEST,
  ADMIN_COMMISSION_DISAPPROVE_FAILURE,
  ADMIN_COMMISSION_DELETE_REQUEST,
  ADMIN_PAYOUTS_DUE_REQUEST,
  ADMIN_PAYOUTS_DUE_RECEIVE,
  ADMIN_PAYOUTS_DUE_FAILURE,
  ADMIN_PAYOUT_MARK_PAID_REQUEST,
  ADMIN_PAYOUT_MARK_PAID_FAILURE,
  ADMIN_PAYOUT_MARK_UNPAID_REQUEST,
  ADMIN_PAYOUT_MARK_UNPAID_FAILURE,
  ADMIN_LOAD_AFFILIATE_RESOURCE_REQUEST,
  ADMIN_LOAD_AFFILIATE_RESOURCE_RECEIVE,
  ADMIN_LOAD_AFFILIATE_RESOURCE_FAILURE
} from 'redux-types/admin'

/**
 * Reducer
 */

const initialState = {
  programs: {
    loading: false,
    loaded: false,
    error: false
  },
  program: {
    loading: false,
    loaded: false,
    error: false
  },
  affiliate: {
    loading: false,
    loaded: false,
    error: false
  },
  conversions: {
    loading: false,
    loaded: false,
    error: false
  },
  payouts: {
    loading: false,
    loaded: false,
    error: false
  }
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case ADMIN_CLEAR:
      return {
        ...initialState
      }

    case ADMIN_PARTNERS_PROGRAMS_REQUEST:
      return {
        ...state,
        programs: {
          loading: true,
          loaded: false,
          error: false
        }
      }

    case ADMIN_PARTNERS_PROGRAMS_RECEIVE:
      return {
        ...state,
        programs: {
          loading: false,
          loaded: true,
          error: false,
          ...action.programs
        }
      }

    case ADMIN_PARTNERS_PROGRAMS_FAILURE:
      return {
        ...state,
        programs: {
          loading: false,
          loaded: false,
          error: true
        }
      }

    case ADMIN_PARTNERS_PROGRAM_REQUEST:
      return {
        ...state,
        program: {
          loading: true,
          loaded: false,
          error: false
        }
      }

    case ADMIN_PARTNERS_PROGRAM_RECEIVE:
      return {
        ...state,
        program: {
          loading: false,
          loaded: true,
          error: false,
          ...action.program
        }
      }

    case ADMIN_PARTNERS_PROGRAM_FAILURE:
      return {
        ...state,
        program: {
          loading: false,
          loaded: false,
          error: true
        }
      }

    case ADMIN_AFFILIATE_PROGRESS_REQUEST:
      return {
        ...state,
        affiliate: {
          loading: true,
          loaded: false,
          error: false
        }
      }

    case ADMIN_AFFILIATE_PROGRESS_RECEIVE:
      return {
        ...state,
        affiliate: {
          loading: false,
          loaded: true,
          error: false,
          ...action.affiliate
        }
      }

    case ADMIN_AFFILIATE_PROGRESS_FAILURE:
      return {
        ...state,
        affiliate: {
          loading: false,
          loaded: false,
          error: true
        }

      }

    case ADMIN_PENDING_COMMISSIONS_REQUEST:
      return {
        ...state,
        conversions: {
          loading: true,
          loaded: false,
          error: false
        }
      }

    case ADMIN_PENDING_COMMISSIONS_RECEIVE:
      return {
        ...state,
        conversions: {
          loading: false,
          loaded: true,
          error: false,
          ...action.conversions
        }
      }

    case ADMIN_PENDING_COMMISSIONS_FAILURE:
      return {
        ...state,
        conversions: {
          loading: false,
          loaded: false,
          error: true
        }
      }

    case ADMIN_COMMISSION_APPROVE_REQUEST:
      return {
        ...state,
        conversions: {
          ...state.conversions,
          data: _mark_commission({
            ...action,
            approved: true
          })(state.conversions.data)
        }
      }

    case ADMIN_COMMISSION_APPROVE_FAILURE:
      return {
        ...state,
        conversions: {
          ...state.conversions,
          data: _mark_commission({
            ...action,
            approved: false
          })(state.conversions.data)
        }
      }

    case ADMIN_COMMISSION_DISAPPROVE_REQUEST:
      return {
        ...state,
        conversions: {
          ...state.conversions,
          data: _mark_commission({
            ...action,
            approved: false
          })(state.conversions.data)
        }
      }

    case ADMIN_COMMISSION_DISAPPROVE_FAILURE:
      return {
        ...state,
        conversions: {
          ...state.conversions,
          data: _mark_commission({
            ...action,
            approved: false
          })(state.conversions.data)
        }
      }

    case ADMIN_COMMISSION_DELETE_REQUEST:
      const remove = _remove_commission(action)
      return {
        ...state,
        conversions: {
          ...state.conversions,
          data: remove(state.conversions.data)
        }
      }

    case ADMIN_PAYOUTS_DUE_REQUEST:
      return {
        ...state,
        payouts: {
          loading: true,
          loaded: false,
          error: false
        }
      }

    case ADMIN_PAYOUTS_DUE_RECEIVE:
      return {
        ...state,
        payouts: {
          loading: false,
          loaded: true,
          error: false,
          ...action.payouts
        }
      }

    case ADMIN_PAYOUTS_DUE_FAILURE:
      return {
        ...state,
        payouts: {
          loading: false,
          loaded: false,
          error: true
        }
      }

    case ADMIN_PAYOUT_MARK_PAID_REQUEST:
      return {
        ...state,
        payouts: {
          ...state.payouts,
          data: _mark_payout({
            ...action,
            paid: true
          })(state.payouts.data)
        }
      }

    case ADMIN_PAYOUT_MARK_PAID_FAILURE:
      return {
        ...state,
        payouts: {
          ...state.payouts,
          data: _mark_payout({
            ...action,
            paid: false
          })(state.payouts.data)
        }
      }

    case ADMIN_PAYOUT_MARK_UNPAID_REQUEST:
      return {
        ...state,
        payouts: {
          ...state.payouts,
          data: _mark_payout({
            ...action,
            paid: false
          })(state.payouts.data)
        }
      }

    case ADMIN_PAYOUT_MARK_UNPAID_FAILURE:
      return {
        ...state,
        payouts: {
          ...state.payouts,
          data: _mark_payout({
            ...action,
            paid: true
          })(state.payouts.data)
        }
      }

    case ADMIN_LOAD_AFFILIATE_RESOURCE_REQUEST:
      const current = state.affiliate[action.resource].data
      return {
        ...state,
        affiliate: {
          ...state.affiliate,
          [action.resource]: {
            ...state.affiliate[action.resource],
            loading_more: true,
            error: false,
            data: action.refresh ? [] : current
          }
        }
      }

    case ADMIN_LOAD_AFFILIATE_RESOURCE_RECEIVE:
      const prior = state.affiliate[action.resource].data
      const { data, ...other } = action.payload
      return {
        ...state,
        affiliate: {
          ...state.affiliate,
          [action.resource]: {
            ...state.affiliate[action.resource],
            ...other,
            loading_more: false,
            error: false,
            data: prior.concat(data)
          }
        }
      }

    case ADMIN_LOAD_AFFILIATE_RESOURCE_FAILURE:
      return {
        ...state,
        affiliate: {
          ...state.affiliate,
          [action.resource]: {
            ...state.affiliate[action.resource],
            loading_more: false,
            error: true
          }
        }
      }

    default:
      return state
  }
}

export function _mark_commission ({ conversion_id, commission_id, approved = true }) {
  return (conversions) => {
    return conversions.map((o) => {
      if (o._id === conversion_id) {
        return {
          ...o,
          commissions: o.commissions.map((j) => {
            return j._id === commission_id
              ? { ...j, approved }
              : j
          })
        }
      } else {
        return o
      }
    })
  }
}

export function _remove_commission ({ conversion_id, commission_id }) {
  return (conversions) => {
    return conversions.map((o) => {
      if (o._id === conversion_id) {
        return {
          ...o,
          commissions: o.commissions.filter((j) => {
            return j._id !== commission_id
          })
        }
      } else {
        return o
      }
    })
  }
}

export function _mark_payout ({ affiliate_id, paid = true, meta = {} }) {
  return (payouts) => {
    return payouts.map((o) => {
      return o.affiliate_id === affiliate_id
        ? { ...o, paid, meta: { ...o.meta, ...meta } }
        : o
    })
  }
}
